import Api from '../Api';

import { url } from './config';
import { City } from './types';

const api = new Api<City>(url);

export default api;
